// extracted by mini-css-extract-plugin
module.exports = {"deleteElement":"global_deleteElement__Q3VQZ"};